import { render, staticRenderFns } from "./MeetGreetChangedMind.vue?vue&type=template&id=85f68da4&"
import script from "./MeetGreetChangedMind.vue?vue&type=script&lang=js&"
export * from "./MeetGreetChangedMind.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports